import React,{Fragment, useState, useEffect} from 'react'
import { useLocation } from "react-router-dom";
import {CAPTabs} from "./CAPTabs";
import { MobileWarning } from './MobileWarning';
import { CutoffMasterProvider, SeatMasterProvider } from '../store/MasterDataContext';

export const CAPZone = () => {
  let location = useLocation();
  
  // Helper function to get tab index from pathname
  const getTabIndexFromPath = (pathname) => {
    if (pathname.includes("nirf-rankings")) return 0;
    if (pathname.includes("caps-dates")) return 1;
    if (pathname.includes("caps-notices")) return 2;
    if (pathname.includes("seat-matrix")) return 3;
    if (pathname.includes("rank-cutoffs")) return 4;
    return 0; // default tab
  };
  
  // Initialize tabIndex based on current pathname
  const [tabIndex, setTabIndex] = useState(() => {
    if (location.state && location.state.tabId !== undefined) {
      return location.state.tabId;
    }
    return getTabIndexFromPath(location.pathname);
  });
  
  useEffect(() => {
    if (location.state && location.state.tabId !== undefined) {
      setTabIndex(location.state.tabId);
    } else {
      // No state passed → fallback to path detection
      setTabIndex(getTabIndexFromPath(location.pathname));
    }
  }, [location])
  
  return (
    <Fragment>
      <MobileWarning/>
      <div className="w-100vh h-auto">
          <CutoffMasterProvider>
            <SeatMasterProvider>
                <CAPTabs tabId={tabIndex} />
            </SeatMasterProvider>
          </CutoffMasterProvider>
      </div>
    </Fragment>
  );
}

